@if (bucket(); as bucketValue) {
<div class="balance-amount">
  <span
    [class.good]="isPositiveBalance()"
    [class.bad]="isNegativeBalance()"
    [class.warn]="isWarningBalance()"
  >
    @if ((showDecimals() === false || (bucketValue.fund?.balance ?? 0) > 10) && showDecimals() !== true) {
      {{ bucketService.getBalance(bucketValue) | currency: 'USD':'symbol':'1.0-0' }}
    } @else {
      {{ bucketService.getBalance(bucketValue) | currency: 'USD':'symbol':'1.2-2' }}
    }
  </span>
</div>
}
